import * as CONST from "./actionTypes";

const intialState = {
  emailTemplates: [],
  smsTemplates: [],
  smsTempByType: [],
  emailTempByType: [],
  error: null,
};

const EmailTempReducer = (state = intialState, { type, payload }) => {
  switch (type) {
    case CONST.EMAIL_TEMP_LIST:
      return {
        ...state,
        error: null,
      };
    case CONST.EMAIL_TEMP_LIST_SUCCESS:
      return {
        ...state,
        emailTemplates: payload,
        error: null,
      };
    case CONST.EMAIL_TEMP_LIST_FAIL:
      return {
        ...state,
        error: payload,
      };

    /* >>>>>>>>>>>>>> EDIT CUSTOMER >>>>>>>>>>>>>>>*/

    case CONST.EMAIL_TEMP_ID:
      return {
        ...state,
        error: null,
      };
    case CONST.EMAIL_TEMP_ID_SUCCESS:
      return {
        ...state,
        emailTemplates: payload,
        error: null,
      };
    case CONST.EMAIL_TEMP_ID_FAIL:
      return {
        ...state,
        error: payload,
      };
    /* >>>>>>>>>>>>>> UPDATE CUSTOMER >>>>>>>>>>>>>>>*/

    case CONST.UPDATE_EMAIL_TEMP:
      return {
        ...state,
        error: null,
      };
    case CONST.UPDATE_EMAIL_TEMP_SUCCESS:
      return {
        ...state,
        emailTemplates: { ...payload },
        error: null,
      };
    case CONST.UPDATE_EMAIL_TEMP_FAIL:
      return {
        ...state,
        error: payload,
      };
    /* >>>>>>>>>>>>>> ADD CUSTOMER >>>>>>>>>>>>>>>*/

    case CONST.ADD_EMAIL_TEMP:
      return {
        ...state,
        error: null,
      };
    case CONST.ADD_EMAIL_TEMP_SUCCESS:
      return {
        ...state,
        emailTemplates: { ...payload },
        error: null,
      };
    case CONST.ADD_EMAIL_TEMP_FAIL:
      return {
        ...state,
        error: payload,
      };

    /* >>>>>>>>>>>>>> DELETE CUSTOMER >>>>>>>>>>>>>>>*/

    case CONST.DELETE_EMAIL_TEMP:
      return {
        ...state,
        error: null,
      };
    case CONST.DELETE_EMAIL_TEMP_SUCCESS:
      return {
        ...state,
        emailTemplates: payload,
        error: null,
      };
    case CONST.DELETE_EMAIL_TEMP_FAIL:
      return {
        ...state,
        error: payload,
      };

    // SMS ============== //

    case CONST.SMS_TEMP_LIST:
      return {
        ...state,
        smsTemplates: {},
        error: null,
      };
    case CONST.SMS_TEMP_LIST_SUCCESS:
      return {
        ...state,
        smsTemplates: payload,
        error: null,
      };
    case CONST.SMS_TEMP_LIST_FAIL:
      return {
        ...state,
        error: payload,
      };

    /* >>>>>>>>>>>>>> EDIT CUSTOMER >>>>>>>>>>>>>>>*/

    case CONST.SMS_TEMP_ID:
      return {
        ...state,
        smsTemplates: {},
        error: null,
      };
    case CONST.SMS_TEMP_ID_SUCCESS:
      return {
        ...state,
        smsTemplates: payload,
        error: null,
      };
    case CONST.SMS_TEMP_ID_FAIL:
      return {
        ...state,
        error: payload,
      };
    /* >>>>>>>>>>>>>> UPDATE CUSTOMER >>>>>>>>>>>>>>>*/

    case CONST.UPDATE_SMS_TEMP:
      return {
        ...state,
        smsTemplates: {},
        error: null,
      };
    case CONST.UPDATE_SMS_TEMP_SUCCESS:
      return {
        ...state,
        smsTemplates: { ...payload },
        error: null,
      };
    case CONST.UPDATE_SMS_TEMP_FAIL:
      return {
        ...state,
        error: payload,
      };
    /* >>>>>>>>>>>>>> ADD CUSTOMER >>>>>>>>>>>>>>>*/

    case CONST.ADD_SMS_TEMP:
      return {
        ...state,
        smsTemplates: {},
        error: null,
      };
    case CONST.ADD_SMS_TEMP_SUCCESS:
      return {
        ...state,
        smsTemplates: { ...payload },
        error: null,
      };
    case CONST.ADD_SMS_TEMP_FAIL:
      return {
        ...state,
        error: payload,
      };

    /* >>>>>>>>>>>>>> DELETE CUSTOMER >>>>>>>>>>>>>>>*/

    case CONST.DELETE_SMS_TEMP:
      return {
        ...state,
        smsTemplates: {},
        error: null,
      };
    case CONST.DELETE_SMS_TEMP_SUCCESS:
      return {
        ...state,
        smsTemplates: payload,
        error: null,
      };
    case CONST.DELETE_SMS_TEMP_FAIL:
      return {
        ...state,
        error: payload,
      };

    /* >>>>>>>>>>>>>> EMAIL TEMP BY TYPE >>>>>>>>>>>>>>>*/

    case CONST.EMAIL_TEMP_BY_TYPE:
      return {
        ...state,
        emailTempByType: {},
        error: null,
      };
    case CONST.EMAIL_TEMP_BY_TYPE_SUCCESS:
      return {
        ...state,
        emailTempByType: payload,
        error: null,
      };
    case CONST.EMAIL_TEMP_BY_TYPE_FAIL:
      return {
        ...state,
        error: payload,
      };

    /* >>>>>>>>>>>>>> SMS TEMP BY TYPE >>>>>>>>>>>>>>>*/

    case CONST.SMS_TEMP_BY_TYPE:
      return {
        ...state,
        smsTempByType: {},
        error: null,
      };
    case CONST.SMS_TEMP_BY_TYPE_SUCCESS:
      return {
        ...state,
        smsTempByType: payload,
        error: null,
      };
    case CONST.SMS_TEMP_BY_TYPE_FAIL:
      return {
        ...state,
        error: payload,
      };

    default:
      return state;

      break;
  }
};

export default EmailTempReducer;
